import { environment } from 'environments/environment';
import posthog from 'posthog-js';
import { redactAccessTokens } from './access-token-url';

function isEnabled(): boolean {
    return !!environment.postHogEnabled && !!environment.posthogApiKey;
}

export function initPostHog(): void {
    if (!isEnabled()) {
        return;
    }

    posthog.init(environment.posthogApiKey, {
        api_host: 'https://us.i.posthog.com',
        // 'history_change' also captures pageviews on Angular's pushState/popstate
        // navigations. Plain `true` only captures a single pageview at init time,
        // which in an SPA means every session is reported as one page.
        capture_pageview: 'history_change',
        // main.ts removes the login token from the URL before this runs. This is
        // a second line of defense if one still reaches an event. Session replay
        // snapshots are skipped: they hold the page DOM and are costly to copy.
        before_send: (event) =>
            event && event.event !== '$snapshot' ? redactAccessTokens(event) : event
    });
}

export function capturePostHogEvent(event: string, properties?: Record<string, unknown>): void {
    if (!isEnabled()) {
        return;
    }

    posthog.capture(event, properties);
}

// Clears the identified person so the next user on this browser does not inherit
// the previous user's distinct id.
export function resetPostHog(): void {
    if (!isEnabled()) {
        return;
    }

    posthog.reset();
}
